'use strict';
var parent = require('../../es/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/get-own-property-symbols.js
// module id = 778
// module chunks = 13